interface PortalEmergencyFallbackOptions {
  readonly reload?: () => void;
}

export function renderPortalEmergencyFallback(
  container: HTMLElement,
  options: PortalEmergencyFallbackOptions = {},
) {
  const ownerDocument = container.ownerDocument;
  const main = ownerDocument.createElement("main");
  const card = ownerDocument.createElement("div");
  const kicker = ownerDocument.createElement("p");
  const heading = ownerDocument.createElement("h1");
  const detail = ownerDocument.createElement("p");
  const actions = ownerDocument.createElement("div");
  const reloadButton = ownerDocument.createElement("button");
  const homeLink = ownerDocument.createElement("a");

  main.id = "portal-root-content";
  main.className = "portal-root-error";
  main.setAttribute("aria-labelledby", "portal-root-error-title");
  main.setAttribute("aria-describedby", "portal-root-error-detail");
  card.className = "portal-error-card";
  kicker.className = "portal-kicker";
  kicker.textContent = "Secure portal";
  heading.id = "portal-root-error-title";
  heading.tabIndex = -1;
  heading.dataset.mainFocus = "";
  heading.dataset.routeFocus = "";
  heading.textContent = "We couldn’t open the portal.";
  detail.id = "portal-root-error-detail";
  detail.textContent =
    "Your private information is safe. Reload the portal or return to portal home.";
  actions.className = "portal-error-actions";
  reloadButton.type = "button";
  reloadButton.textContent = "Reload portal";
  reloadButton.addEventListener("click", () => {
    (options.reload ?? (() => window.location.reload()))();
  });
  homeLink.setAttribute("href", "/");
  homeLink.textContent = "Portal home";

  actions.append(reloadButton, homeLink);
  card.append(kicker, heading, detail, actions);
  main.append(card);
  container.replaceChildren(main);

  const focusHeading = () => {
    heading.focus({ preventScroll: true });
    heading.scrollIntoView({ block: "start" });
  };
  const view = ownerDocument.defaultView;
  if (view) {
    view.requestAnimationFrame(focusHeading);
  } else {
    focusHeading();
  }

  return main;
}
